import React from "react";
import { useEffect } from "react";
import "./App.css";
import Navbar from "./Navbar";
import MenuGrid from "./MenuGrid";
import Sidebar from "./Sidebar";

function App() {
  // Set the document title on component mount
  useEffect(() => {
    document.title = "Piperwoods";
  }, []);

  return (
    <div className="App">
      <header className="header">
        <img
          src="images/portrait158.webp"
          alt="Piper Woods"
          className="header-image"
        />
        <div className="header-text">
          <h1>Piper Woods</h1>
          <p>Music Education for Beginning Students</p>
        </div>
      </header>
      <Navbar />
      <div className="main-container">
        <div className="main-grid">
          <MenuGrid />
        </div>
        <Sidebar />
        <div className="about-section" id="about-section">
          <h2>About Me</h2>
          <p>
            My name is Piper Woods. I am a squirrel who wants to help beginning
            music students get off to a good start. I live with a human, Michael
            Eldridge, who has been teaching piano for over 30 years. I have
            listened to him giving private lessons, and I think I have a pretty
            good idea of areas where beginning students need the most help.
          </p>
          <p>If you live in San Jose, California and are interested in private piano lessons, you can contact Michael at <a href="http://michaeleldridgepiano.com">michaeleldridgepiano.com</a>.</p>
        </div>
      </div>
      <footer className="footer" id="contact">
        <p>© {new Date().getFullYear()} Piperwoods.com. All rights reserved.</p>
        <p>
          Contact us by email at{" "}
          <a href="mailto:piper@piperwoods.com">piper@piperwoods.com</a>
        </p>
      </footer>{" "}
    </div>
  );
}

export default App;
